<template>
  <div class="cus-modal ChangePassword">
    <div class="clonePopUp">
      <div class="pop-title">
        <div class="pop-input">
          <ul style="list-style:none;">
            <li>
              <span>旧密码：</span>
              <!-- 部分浏览器问题：浏览器保存账号密码用户名回填的颜色（没有autocomplete="off" 部分会不弹框）-->
              <input type="text" :value="userInfo.ename" hidden autocomplete="off">
              <input
                id="ativeFocus"
                autocomplete="off"
                v-model="oldpaswd"
                :type="isOldpwd ? 'password' : 'text'"
                :class="['ark-input', 'ark-input-default', {'borderactive':inconformity1}]"
                @focus="focus($event,1)"
              >
              <Icon :type="isOldpwd ? 'ios-eye-outline' : 'ios-eye-off-outline'" slot="suffix" @click="isOldpwd = !isOldpwd" />
              <!-- <input
                type="password"
                name="password1"
                style="display:none"
              > -->
              <p
                v-show="oldp"
                :style="{ color: errorpawdgrade}"
              >
                请输入旧密码
              </p>
            </li>
            <li>
              <span>新密码：</span>
              <input
                v-model="newpaswd"
                autocomplete="off"
                :class="{'borderactive':inconformity2}"
                :type="isNewpwd ? 'password' : 'text'"
                @blur="blur()"
                @input="changwd()"
                @focus="focus($event,2)"
              >
              <Icon :type="isNewpwd ? 'ios-eye-outline' : 'ios-eye-off-outline'" slot="suffix" @click="isNewpwd = !isNewpwd" />
              <!-- <input
                type="password"
                name="password1"
                style="display:none"
              > -->
              <p
                v-show="pawdgrade1"
                :style="{ color: errorpawdgrade1}"
              >
                {{ this.newHint }}
              </p>
              <p v-show="pawdgrade">
                密码安全程度：<b :style="{ color: activeColor}">{{ grade }}</b>
              </p>
            </li>
            <li>
              <span>确认密码：</span>
              <input
                v-model="againpaswd"
                autocomplete="off"
                :class="{'borderactive':inconformity3}"
                :type="isConfirmpwd ? 'password' : 'text'"
                @blur="blur(3)"
                @focus="focus($event,3)"
              >
              <Icon :type="isConfirmpwd ? 'ios-eye-outline' : 'ios-eye-off-outline'" slot="suffix" @click="isConfirmpwd = !isConfirmpwd" />
              <!-- <input
                type="password"
                name="password1"
                style="display:none"
              > -->
              <p
                v-show="inconformity3"
                :style="{ color: error}"
              >
                两次输入的密码不一致
              </p>
            </li>
          </ul>
        </div>
      </div>
      <OmsButton class="modal-footer" :btn-config="btnConfig" />
    </div>
  </div>
</template>

<script type="text/javascript">
  import { pwd } from '@/assets/js/__utils__/regx.js'
  import { mapActions, mapState } from "vuex";
  export default {
    name: 'ChangePassword',
    data() {
      return {
        isOldpwd: true,
        isNewpwd: true,
        isConfirmpwd: true,
        title: '修改密码', // 标题
        oldpaswd: '',
        newpaswd: '',
        pawdgrade2: false,
        errorpawdgrade: 'red',
        errorpawdgrade1: '#818181',
        newHint: '密码为8-20位，至少包含大小写字母/数字/符号 3种组合',
        againpaswd: '',
        pop_dialog: false,
        activeColor: 'red', // 控制密码强度的时候，颜色
        error: 'red',
        grade: '低', // 密码等级
        oldp: false, // 旧密码是否错误
        pawdgrade: false, // 显示密码等级
        pawdgrade1: true, // 密码长度
        inconformity1: false, // input错误border颜色class
        inconformity2: false, // input错误border颜色class
        inconformity3: false, // input错误border颜色class
        reg: new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{6,18}$/),
        btnConfig: {
          typeAll: 'default', // 按钮统一风格样式
          btnsite: 'right', // 按钮位置 (right , center , left)
          buttons: [
            {
              text: $it('com.cancel'), // 取消 按钮文本
              btnclick: () => {
                this.$emit('close')
              } // 按钮点击事件
            },
            {
              type: 'primary', // 按钮类型
              text: $it('com.determine'), // 确定 按钮文本
              btnclick: () => {
                this.save();
              }
            }
          ]
        },
    };
    },
    computed: {
      ...mapState('global', ['userInfo']),
    },
    mounted() {
      this.$nextTick(() => {
        $('.ark-drawer.ark-drawer-right.ark-drawer-no-header').parent()[1].click() // 隐藏框架个人中心侧视图
      })
      document.getElementById('ativeFocus').focus();
    },
    methods: {
      ...mapActions('global', ['signout']),
      changwd() { // 修改密码，显示密码强度
        this.pawdgrade = false;
        this.pawdgrade1 = true;
      },
      blur(num) { // 失焦时判断密码
        if (pwd.test(this.newpaswd) && num == 3) {
          if (this.newpaswd !== this.againpaswd) { // 两次密码不一样
            this.inconformity3 = true;
          }
          return
        }
        if (this.newpaswd === '') {
          this.pawdgrade1 = true;
          this.errorpawdgrade1 = 'red';
          this.inconformity2 = true;
          this.newHint = '请输入新密码';
        } else if (this.oldpaswd == this.newpaswd) {
          this.pawdgrade1 = true;
          this.errorpawdgrade1 = 'red';
          this.inconformity2 = true;
          this.newHint = '新旧密码必须不一致';
        } else if (this.newpaswd.length >= 8 && this.newpaswd.length <= 20) {
          if (!pwd.test(this.newpaswd)) {
            this.newHint = '密码为8-20位，至少包含大小写字母/数字/符号 3种组合';
            this.errorpawdgrade1 = 'red';
            this.inconformity2 = true;
            this.pawdgrade1 = true;
            return
          }
          this.errorpawdgrade1 = '#818181';
          this.newHint = '密码为8-20位，至少包含大小写字母/数字/符号 3种组合';
        } else {
          this.newHint = '密码为8-20位，至少包含大小写字母/数字/符号 3种组合';
          this.errorpawdgrade1 = 'red';
          this.inconformity2 = true;
          this.pawdgrade1 = true;
        }
      },
      focus(e, num) { // 聚焦清除提示
        switch (num) {
        case 1: this.oldp = false; this.inconformity1 = false;
                break;
        case 2: this.pawdgrade = false; this.pawdgrade1 = true; this.inconformity2 = false; this.errorpawdgrade1 = '#818181'; this.newHint = '密码为8-20位，至少包含大小写字母/数字/符号 3种组合';
                break;
        default: this.inconformity3 = false;
        }
      },
      save() { // 保存
        if (!this.oldpaswd) { // 如果旧密码为空
          this.oldp = true;
          this.inconformity1 = true;
          return false;
        }
        if (this.newpaswd === '') { // 新密码为空
          this.pawdgrade1 = true;
          this.errorpawdgrade1 = 'red';
          return false;
        }
        if (this.newpaswd.length < 8) { // 密码长度小于8
          this.pawdgrade = false;
          this.errorpawdgrade1 = 'red';
          this.pawdgrade1 = true;
          return false;
        }
        if (this.newpaswd.length > 20) { // 密码长度大于20
          this.pawdgrade = false;
          this.errorpawdgrade1 = 'red';
          this.pawdgrade1 = true;
          return false;
        }
        if (this.againpaswd === '') { // 再次输入密码为空
          this.inconformity3 = true;
          return false;
        }
        if (!pwd.test(this.newpaswd)) {
          this.pawdgrade = false;
          this.errorpawdgrade1 = 'red';
          this.pawdgrade1 = true;
          return false;
        }
        if (this.newpaswd !== this.againpaswd) { // 两次密码不一样
          this.inconformity3 = true;
          return false;
        }
        this.service.common.changechruserpwd({
          oldpassword: this.oldpaswd,
          newpassword: this.newpaswd,
          confirmpassword: this.againpaswd
        }).then((res) => {
          if (res.data.code === 0) {
            // const message = {
            //   title: '成功',
            //   content: res.data.message
            // };
            // this.$Modal.fcSuccess(message);
            this.newpaswd = '';
            this.againpaswd = '';
            this.signout()
          }
        });
        return true;
      }
    }
  };
</script>
<style lang="less" scoped>
.ChangePassword {
  width: 100%;
}
.ChangePassword .clonePopUp .pop-input {
  span {
    width: 100px;
  }
  input { 
    width: 290px;
    border-radius: 2px;
    color: #575757;
    height: 28px;
    line-height: 28px;
    padding-right: 26px;
  }
  p {
    padding-left: 100px;
  }
}

.iconios-eye-outline, .iconios-eye-off-outline {
  position: relative;
  left: -24px;
  top: -1px;
  font-size: 18px;
  color: #8c8a8a;
}
</style>